import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { YearOfPassing } from '@app/_models/yearOfPassing';
import { YearOfPassingService } from '@app/_services/masters/yearOfPassing.service';
import { LogService } from '@app/_shared/log.service';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { first } from 'rxjs/operators';

@Component({
  selector: 'app-passing-year-master-add',
  templateUrl: './passing-year-master-add.component.html',
  styleUrls: ['./passing-year-master-add.component.css']
})
export class PassingYearMasterAddComponent implements OnInit {

  year = new YearOfPassing();
  constructor(private eventService: LogService, private formBuilder: FormBuilder, private yearOfPassService: YearOfPassingService,
    private modalService: NgbModal, config: NgbModalConfig, private router: Router) { }

  yearForm: FormGroup;
  submitted = false;
  strMessage:string;
  getresponse: any;
  monthDropDown:any;  
  returnUrl;

  @ViewChild('showModalBox', { read: TemplateRef }) showModalBoxTemplate: TemplateRef<any>;

  ngOnInit(): void {
    this.yearForm = this.formBuilder.group({
      id:"",
      yearOfPass: ['', Validators.required]
      // month:['',Validators.required]
    });

    this.yearOfPassService.geMonths()
    .pipe(first())
    .subscribe(
      data => {
        this.monthDropDown = data.respData;
        console.log("monthDropDown",data.respData)
      },
      error => {
        console.log(error)
      })
  }

  get f() { return this.yearForm.controls; }

  addYear(){
    this.submitted = true;

    if (this.yearForm.invalid) {
      return;
    }
    
    console.log(this.year)
    
    this.yearOfPassService.addYear(this.year)
    .subscribe((response) => {
      if (response) {
        this.getresponse = response;
        if (this.getresponse.respMessage == "Success") {
          this.strMessage="Year Added Successfully.";
          this.modalService.open(this.showModalBoxTemplate);
          var v = response;
        }
 
      else if (this.getresponse.respMessage == "Failure") {
        this.strMessage=this.getresponse.respData;
        this.modalService.open(this.showModalBoxTemplate);
        var v = response;
      }
    }
    },
      (err: any) => {
        var message = err;
      });

  }

  refresh(): void {
    this.modalService.dismissAll(this.showModalBoxTemplate);
    this.eventService.emit<string>('35');
  }

  goBack()
  {
    this.eventService.emit<string>('35');
  }

}
